/**
 * External Dependencies
 */
import classnames from 'classnames'; //npm install classnames --save

/* https://jeffreycarandang.com/extending-gutenberg-core-blocks-with-custom-attributes-and-controls/ */

/**
 * WordPress Dependencies
 */
const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { Fragment }	= wp.element;
const { InspectorAdvancedControls }	= wp.blockEditor;
const { createHigherOrderComponent } = wp.compose;
const { ToggleControl } = wp.components;

//restrict to specific block names
const allowedBlocks = [ 'core/columns' ];

/**
 * Add custom attribute for disabling rows.
 *
 * @param {Object} settings Settings for the block.
 *
 * @return {Object} settings Modified settings.
 */
function addAttributes( settings ) {

	//check if object exists for old Gutenberg version compatibility
	//add allowedBlocks restriction
	if( typeof settings.attributes !== 'undefined' && allowedBlocks.includes( settings.name ) ){

		settings.attributes = Object.assign( settings.attributes, {
			showRow:{
				type: 'boolean',
				default: true
			}
		});

	}

	return settings;
}

/**
 * Add row disabling controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {

		const {
			name,
			attributes,
			setAttributes,
			isSelected,
		} = props;

		const {
			showRow,
		} = attributes;


		return (
			<Fragment>
				<BlockEdit {...props} />
				{ isSelected && allowedBlocks.includes( name ) &&
					<InspectorAdvancedControls>
						<ToggleControl
							label={ __( 'Show Row On Website' ) }
							checked={ !! showRow }
							onChange={ () => setAttributes( {  showRow: ! showRow } ) }
							help={ !! showRow ? __( 'Showing on website.' ) : __( 'Removed from website.' ) }
							__nextHasNoMarginBottom={ true }
						/>
					</InspectorAdvancedControls>
				}

			</Fragment>
		);
	};
}, 'withAdvancedControls');

/* Apply the adjustment in the editor too */  // https://wordpress.stackexchange.com/questions/324091/
const withRowDisabled = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {

	if ( allowedBlocks.includes( props.name )) {
        if (props.attributes.showRow){
	    	return <BlockListBlock {...props} />
		} else {
            //return <BlockListBlock { ...props } className={ 'row-disabled' } />;
            return <BlockListBlock { ...props } className={classnames( props.className, 'row-disabled' )} />;
       	}
	} else {
           	return <BlockListBlock {...props} />
    }

    };
}, 'withClientIdClassName' );

wp.hooks.addFilter( 'editor.BlockListBlock', 'pwd-blocks/with-client-id-class-name', withRowDisabled )


/**
 * Add custom element class in save element.
 *
 * @param {Object} extraProps     Block element.
 * @param {Object} blockType      Blocks object.
 * @param {Object} attributes     Blocks attributes.
 *
 * @return {Object} extraProps Modified block element.
 */
function applyExtraClass( extraProps, blockType, attributes ) {

	const { showRow } = attributes;

	//check if attribute exists for old Gutenberg version compatibility
	//add class only when showRow = false
	//add allowedBlocks restriction
	if ( typeof showRow !== 'undefined' && !showRow && allowedBlocks.includes( blockType.name ) ) {
		extraProps.className = classnames( extraProps.className, 'row-disabled' );
	}

	return extraProps;
}

//add filters

addFilter(
	'blocks.registerBlockType',
	'pwd-blocks/custom-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'pwd-blocks/custom-advanced-control',
	withAdvancedControls
);

addFilter(
	'blocks.getSaveContent.extraProps',
	'pwd-blocks/applyExtraClass',
	applyExtraClass
);